// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"63091d87","227":"9e57a6d0","409":"4487cede","529":"00d45952","949":"9516769b","963":"6d466016"}[chunkId] + ".chunk.js";
};